import React from 'react';
import Slider from 'react-slick';
import './Carousel.css';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';

// Importe suas imagens do carrossel
import slide1 from '../../assets/images/carro-bateria.jpg';
import slide2 from '../../assets/images/profissional-troca.jpg';

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
  };

  const phoneNumber = '3133602809';
  const whatsappMessage = 'Olá! Preciso de uma bateria. Pode me ajudar?';

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {/* Slide 1 */}
        <div className="slide">
          <img src={slide1} alt="Baterias para todos os tipos de veículos" />
          <div className="slide-caption">
            <h1>BATERIA PARA CARROS, MOTOS E CAMINHÕES EM BELO HORIZONTE E REGIÃO</h1>
            <p>Entrega Rápida e Instalação Especializada com as Melhores Marcas</p>
          </div>
        </div>
        {/* Slide 2 */}
        <div className="slide">
          <img src={slide2} alt="Profissional realizando a troca de bateria" />
          <div className="slide-caption">
            <h2>Ficou sem bateria e procura uma loja realmente especializada?</h2>
            <p>Só aqui você encontra a troca segura de bateria para seu veículo.</p>
          </div>
        </div>
      </Slider>
      <div className="carousel-cta">
         <a href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(whatsappMessage)}`} 
            target="_blank" rel="noopener noreferrer" className="cta-button whatsapp">
            <FaWhatsapp /> Peça pelo WhatsApp
         </a>
         <a href={`tel:${phoneNumber}`} className="cta-button phone">
            <FaPhoneAlt /> LIGUE E PEÇA JÁ!
         </a>
      </div>
    </div>
  );
}

export default Carousel;